import { Component, OnInit } from '@angular/core';
import { TuningsTextService } from '../LIB/services/tunings-text.service';

@Component({
  selector: 'app-about',
  templateUrl: './about.page.html',
  styleUrls: ['./about.page.scss'],
})
export class AboutPage implements OnInit {
  constructor(
    public tuningsTextService: TuningsTextService
  ) { }

  ngOnInit() {
  }

}
